/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import VideoPlayer from "./VideoPlayer";
import L from "./Lang";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Icon from "./Icon";
import Auth from "../shared/Auth";

class LauncherTutorialModal extends BaseCom {

    defaultTutorial = 'taplocal';

    tutorialPaths = {
        banktech: 'https://solusekbuilder-public.s3.us-east-2.amazonaws.com/tutorial-banktech-es.mp4',
        taplocal: 'https://solusekbuilder-public.s3.us-east-2.amazonaws.com/tutorial-taplocal-en.mp4'
    };

    async componentDidMount() {
        Auth.getLogin(async (u) => {
            if (u) {
                try {
                    let org = await this.getOrg();
                    if (this.tutorialPaths[org.ident]) {
                        this.setState({ src: this.tutorialPaths[org.ident] });
                    }
                    else
                        this.setState({ src: this.tutorialPaths[this.defaultTutorial] });
                }
                catch (e) {
                    console.error(e);
                    this.setState({ src: this.tutorialPaths[this.defaultTutorial] });
                }
            }
        });

    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title><L>Welcome to the Web Builder</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <VideoPlayer src={this.state.src} type="video/mp4" autoplay />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary btn-lg" onClick={this.props.onHide}>
                        <Icon icon="faCaretRight" /> <L>Continue</L>
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default withParamsAndNavigate(LauncherTutorialModal);